import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-youtube-lazy',
  templateUrl: './youtube-lazy.component.html',
  styleUrls: ['./youtube-lazy.component.scss']
})
export class YoutubeLazyComponent {
  @Input() videoId!: string;
  @Input() title: string = '';
  @Input() badge: string = '';
  @Input() date: string = '';

  iframeLoaded = false;
  iframeUrl!: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {}

  loadIframe() {
    const url = `https://www.youtube.com/embed/${this.videoId}?autoplay=1`;
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.iframeLoaded = true;
  }

  get thumbnailUrl(): string {
    return `https://img.youtube.com/vi/${this.videoId}/hqdefault.jpg`;
  }
}
